interface tableNumber {
  pageCurrent: number,
  dataLength: number,
  index: number
}

export const tableNumber = ({pageCurrent, dataLength, index}: tableNumber) => String(pageCurrent * dataLength + (index + 1) - dataLength)